import React from 'react';
import PropTypes from 'prop-types';
import { Timeline } from 'react-twitter-widgets';
import 'whatwg-fetch';

// Import components
import SMHalfTileView from './SMHalfTileView';

// Import assets
import './twitter.scss';

class TwitterController extends React.Component {
  static createCssElement(doc, url) {
    const link = doc.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    return link;
  }

  static embedCss(doc, url) {
    const link = TwitterController.createCssElement(doc, url);
    const head = doc.getElementsByTagName('head')[0];
    head.appendChild(link);
  }

  constructor(props) {
    super(props);

    this.stylesURL = '/dist/css/main.style.css';
    this.onLoad = this.onLoad.bind(this);
  }

  onLoad() {
    const iframes = document.getElementsByTagName('iframe');
    for (let i = 0; i < iframes.length; i += 1) {
      const iframe = iframes[i];
      if (iframe.id.indexOf('twitter-widget') >= 0) {
        TwitterController.embedCss(iframe.contentDocument, this.stylesURL);
      }
    }
  }

  render() {
    const dataSource = {
      sourceType: 'profile',
      screenName: 'ZEISSLenses',
    };

    const options = {
      tweetLimit: 1,
      cards: 'hidden',
      conversation: 'none',
      linkColor: '#055de2',
      align: 'center',
      width: 'auto',
      chrome: 'noheader nofooter noborders transparent noscrollbar',
      ariaPolite: 'assertive',
    };

    const tweet = (<Timeline dataSource={dataSource} options={options} onLoad={this.onLoad} />);

    return (
      <SMHalfTileView {...this.props} textComponent={tweet} />
    );
  }
}

TwitterController.propTypes = {
  url: PropTypes.string,
  type: PropTypes.string,
  tweetID: PropTypes.string,
};

TwitterController.defaultProps = {
  tweetID: '',
  type: 'twitter',
  url: '',
};

export default TwitterController;



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/SMHalfTile/TwitterController.jsx